var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padding-top-10"},[_c('top',{attrs:{"active":1}}),_c('div',{staticClass:"home padding-lr-30 fs30"}),_c('bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }